/* Project Import will be here */
import * as actions from '../actions/history.Action';
/* Project Import will be here */

/* Const,Let & Var will be here */
let initialState = {
    history: {
        previousHistory: ''
    }
};

/* Const,Let & Var will be here */

export default function (state = initialState, action) {
    switch (action.type) {
        case actions.HISTORY:
            return {
                ...state,
                history: {
                    ...state.history,                  
                    previousHistory: action.history
                }
            };            
        default:
            return state;
    }
}